import { useMutation} from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";
import axios from "axios";

const inlineTestSteps = async ({ data, params }) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  const response = await axios
    .post(
      `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=inlineTestSteps&companyid=${user.companyid}`,
      data,
      {
        params,
      },
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error.response.data.error);
    });

  return response.data;
};

const useInlineTestStepsMutation = (options = {}) => {

  return useMutation({
    mutationFn: inlineTestSteps,

    ...options,
  });
};

export default useInlineTestStepsMutation;
